// freezoneConstants.js
'use strict';

export const freezoneType = {
  MODEL: 'model',
  AMATEUR: 'amateur',
};

export const freezoneFeed = {
  MODEL: 'free_peek',
  AMATEUR: 'flix_amateur',
};
